import { Link } from "react-router-dom";
import { ArrowUpRight, ChevronRight, CreditCard, ReceiptText, FileText, ShieldCheck, Check, MessageCircle } from "lucide-react";
import HomeNoticeModal from "../components/HomeNoticeModal";
import JulyFooter from "../components/design/JulyFooter";
import { HomeBanners, InstallmentBenefits } from "../components/design/PublicHomeContent";
import "../styles/mobile-home.css";

export default function MobileAppHome() {
  return <div className="jp-site jm-home">
    <section className="jm-hero" aria-labelledby="jm-home-heading">
      <img src="/design/julyupay-merchant.png" alt="매장에서 스마트폰을 확인하는 사장님" fetchPriority="high" />
      <div className="jm-hero-shade" />
      <div className="jm-container jm-hero-content">
        <span>사장님의 주류대금 결제</span>
        <h1 id="jm-home-heading">주류대금도,<br /><em>내 카드로 여유롭게.</em></h1>
        <p>사장님은 카드로, 거래처에는 계좌로.</p>
        <Link className="jm-primary" to="/registration">결제등록 시작하기<ArrowUpRight size={18} /></Link>
        <Link className="jm-hero-guide" to="/guide">이용방법 보기<ChevronRight size={15} /></Link>
      </div>
    </section>
    <section className="jm-container jm-services" aria-label="주요 서비스">
      <Link className="jm-service" to="/registration"><span className="jm-icon"><CreditCard size={25} /></span><span><strong>주류대금 결제등록</strong><small>보낼 금액부터 확인해 보세요.</small></span><ArrowUpRight size={20} /></Link>
      <Link className="jm-history" to="/pay"><span><ReceiptText size={19} />이용목록 확인하기</span><ChevronRight size={17} /></Link>
      <div className="jm-fee"><div><span>서비스 이용료</span><strong>3.7<small>%</small></strong></div><p>이용료 부가세 별도<br />총 금액은 등록 시 확인하세요.</p></div>
      <p className="jm-trust"><ShieldCheck size={17} />거래 증빙 검토·승인 후 카드결제가 진행돼요.</p>
    </section>
    <HomeBanners />
    <section className="jm-how"><div className="jm-container">
      <h2>등록부터 송금까지,<br />차근차근 안내할게요.</h2>
      <ol>{[
        ["금액 확인", "보낼 금액과 이용료를 먼저 확인하세요."],
        ["서류·송금 정보 등록", "본인확인과 거래 서류, 받는 분 정보를 등록하세요."],
        ["카드결제 후 송금", "승인 후 결제하면 거래처 계좌로 송금돼요."],
      ].map(([title, text], index) => <li key={title}><span>0{index + 1}</span><div><h3>{title}</h3><p>{text}</p></div></li>)}</ol>
      <Link className="jm-text-link" to="/guide">이용방법 자세히 보기<ArrowUpRight size={16} /></Link>
    </div></section>
    <section className="jm-container jm-documents" aria-labelledby="jm-doc-heading">
      <div className="jm-section-title"><h2 id="jm-doc-heading">미리 준비해 주세요.</h2><FileText size={23} /></div>
      <ul>{["견적서 1건", "본인 사업자등록증 1건", "거래처 통장사본 1건"].map(label => <li key={label}><Check size={17} />{label}</li>)}</ul>
      <p>통장사본 대신 기존 거래 이체내역 2건도 가능해요.</p>
    </section>
    <section className="jm-container jm-faq" aria-labelledby="jm-faq-heading">
      <h2 id="jm-faq-heading">궁금한 점이 있나요?</h2>
      <details><summary>어떤 카드로 결제할 수 있나요?<span aria-hidden="true">+</span></summary><p>결제 단계에서 사용 가능한 카드와 할부 조건을 확인할 수 있어요.</p></details>
      <details><summary>진행 상태는 어디서 확인하나요?<span aria-hidden="true">+</span></summary><p>이용목록에서 서류 검토부터 보완 요청, 결제와 송금까지 확인하세요.</p></details>
      <Link className="jm-text-link" to="/faq">질문 전체 보기<ArrowUpRight size={16} /></Link>
      <Link className="jm-support" to="/support"><MessageCircle size={23} /><span><strong>카카오톡으로 상담하세요.</strong><small>평일 09:00~17:30</small></span><ChevronRight size={18} /></Link>
    </section>
    <InstallmentBenefits /><JulyFooter /><HomeNoticeModal />
  </div>;
}
